import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M10.4 1H5.6C4.17 1 3 2.17 3 3.6v8.8C3 13.83 4.17 15 5.6 15h4.8c1.43 0 2.6-1.17 2.6-2.6V3.6C13 2.17 11.83 1 10.4 1m0 2c.325 0 .6.274.6.6v8.8c0 .326-.275.6-.6.6H5.6c-.325 0-.6-.274-.6-.6V3.6c0-.326.275-.6.6-.6h4.8"
        />
        <path
          className="icon-color"
          d="M8.015 9.758c-.691 0-1.25.56-1.25 1.25s.559 1.25 1.25 1.25c.689 0 1.25-.56 1.25-1.25s-.561-1.25-1.25-1.25"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M16 2H8C6.35 2 5 3.35 5 5v14c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3m0 2c.542 0 1 .458 1 1v14c0 .542-.458 1-1 1H8c-.542 0-1-.458-1-1V5c0-.542.458-1 1-1h8"
        />
        <path
          className="icon-color"
          d="M12 16.757c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25"
        />
      </g>
    </svg>
  ),
};
